<template>
  <div class="card" :class="`card-${type}`">
    <div v-if="type == 'small'">
      <div class="card-body position-relative">
        <div v-if="showTooltip" class="info" data-bs-toggle="tooltip" data-bs-placement="right"
          title="The value calculated based on schedule for this month">
          i
        </div>
        <div class="widget-content">
          <div class="image">
            <img :src="img" />
          </div>
          <div>
            <h4 class="title">{{ title }}</h4>
            <span class="subtitle">{{ subtitle }}</span>
            <p v-if="lastseen !== ''" class="subtitle" style="font-size: 13px;">{{ lastseen }}</p>
          </div>
          <div v-bind:key="index" v-for="(item, index) in stacked">
            <h4 class="title">{{ item.label }}</h4>
            <span class="subtitle">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div v-if="value" class="card-footer">
        <!-- @click="openLightModal" -->
        <span @click="openLightModal">See All Streetlights >></span>
      </div>
    </div>
    <div v-if="type == 'plain'">
      <div class="card-body position-relative">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    type: {
      type: String,
      description: "Card type (e.g primary/danger etc)",
    },
    showFooterLine: {
      type: Boolean,
      default: false,
    },
    headerClasses: {
      type: [String, Object, Array],
      description: "Card header css classes",
    },
    bodyClasses: {
      type: [String, Object, Array],
      description: "Card body css classes",
    },
    footerClasses: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    stacked: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    title: {
      type: String,
      description: "Card title",
    },
    img: {
      type: String,
      description: "Card title",
    },
    subtitle: {
      type: String,
      description: "Card title",
    },
    showTooltip: {
      type: String,
      description: "Card title",
    },
    value: {
      type: Boolean,
      default: false,
    },
    lastseen: {
      type: String,
      default: ""
    },
  },
  methods: {
    openLightModal() {
      this.$emit("open-light-modal");
    },
  },
};
</script>
<style></style>
